
const AudienceLogin = () => import('../views/pages/audienceEn/login/audience-login.vue'); // 登录页    

// 页面框架
const AudienceHomeEn = () => import('../views/pages/audienceEn/audience-home.vue');
const AudienceHome1 = () => import('../views/pages/audienceEn/audience-home1.vue');
const Home = () => import('../views/pages/audienceEn/home/index.vue'); // 首页 

const AudienceEnRouter = [

  {
    path: '/en', redirect: 'homeEn', name: 'AudienceHomeEn', component: AudienceHomeEn,
    children: [{ // 首页
      path: '/homeEn',
      name: 'homeEn',
      component: Home
    },
    { // 供需
      path: '/chanceEn',
      name: 'chanceEn',
      component: (resolve) => require(['@views/pages/audienceEn/chance/index'], resolve)
        },
    { // 供需
        path: '/detailGx',
        name: 'detailGx',
      component: (resolve) => require(['@views/pages/audienceEn/chance/detailGx'], resolve)
        },

    { // 资讯
      path: '/newsEn',
      name: 'newsEn',
      component: (resolve) => require(['@views/pages/audienceEn/news/index'], resolve)
    },
    { // 资讯
      path: '/contactEn',
      name: 'contactEn',
      component: (resolve) => require(['@views/pages/audienceEn/contact/index'], resolve)
    },
    { // 关于
      path: '/aboutEn',
      name: 'aboutEn',
      component: (resolve) => require(['@views/pages/audienceEn/about/index'], resolve)
    },
    { // 产品&展商列表
      path: '/ex-listEn',
      name: 'ex-listEn',
      component: (resolve) => require(['@views/pages/audienceEn/ex-list/ex-list'], resolve)
    },
    { // 产品&展商列表
      path: '/ex-listEn2',
      name: 'ex-listEn2',
      component: (resolve) => require(['@views/pages/audienceEn/ex-list/ex-list2'], resolve)
    },
    { // 产品列表
      path: '/pro-listEn',
      name: 'pro-listEn',
      component: (resolve) => require(['@views/pages/audienceEn/pro-list/pro-list'], resolve)
    },
    { // 活动列表
      path: '/act-listEn',
      name: 'act-listEn',
      component: (resolve) => require(['@views/pages/audienceEn/act-list/act-list'], resolve)
    },
    { // xinpinhui
      path: '/act-xinpinhui',
      name: 'act-xinpinhui',
      component: (resolve) => require(['@views/pages/audienceEn/act-xinpinhui/act-list'], resolve)
    },
    { // zhenpinhui
      path: '/act-zhenpinhui',
      name: 'act-zhenpinhui',
      component: (resolve) => require(['@views/pages/audienceEn/act-zhenpinhui/act-list'], resolve)
    },
    { // 商机分类
      path: '/chance-typeEn',
      name: 'chance-typeEn',
      component: (resolve) => require(['@views/pages/audienceEn/chance-type/index'], resolve)
    },
    { // 资讯详情
      path: '/news-detailsEn',
      name: 'news-detailsEn',
      component: (resolve) => require(['@views/pages/audienceEn/news-details/index'], resolve)
    },
    ]
  },
  { // 商机详情
    path: '/chance-detailEn',
    name: 'chance-detailEn',
    component: (resolve) => require(['@views/pages/audienceEn/chance/chance-detail'], resolve)
  },
  { // 活动详情
    path: '/activity-detailsEn/:id',
    name: 'activity-detailsEn',
    component: (resolve) => require(['@views/pages/audienceEn/activity-details/activity-details'], resolve)
  },
  { // 产品详情
    path: '/pro-detailsEn/:id',
    name: 'pro-detailsEn',
    component: (resolve) => require(['@views/pages/audienceEn/pro-details/pro-details'], resolve)
  },
  { // 展商详情
    path: '/ex-detailsEn/:id',
    name: 'ex-detailsEn',
    component: (resolve) => require(['@views/pages/audienceEn/ex-details/ex-details'], resolve)
  },
  // { path: '/chance', name: 'Chance', component: Chance },
  // {
  //     path: 'index', name: 'home', component: AudienceLayout, children: [
  //         { path: 'home', name: 'AudienceHome', component: AudienceHome },
  //         // {
  //         //     path: 'set', redirect: '/audience/index/set/base', name: 'set', component: set, children: [
  //         //         { path: 'base', name: 'base', component: audienceSet },
  //         //         { path: 'classify', name: 'classify', component: audienceSetClassify },
  //         //         { path: 'project', name: 'project', component: audienceSetProject },
  //         //     ]
  //         // },  
  //     ],
  // }, 
  {
    path: '/loginEn', redirect: '/loginEn/aloginEn', name: 'audience-registerEn', component: AudienceLogin, children: [
      { path: 'aloginEn', name: 'aloginEn', component: (resolve) => require(['@views/pages/audienceEn/login/components/a-login'], resolve) },
      { path: 'bloginEn', name: 'bloginEn', component: (resolve) => require(['@views/pages/audienceEn/login/components/b-login'], resolve) },
      { path: 'registerEn', name: 'registerEn', component: (resolve) => require(['@views/pages/audienceEn/login/components/register'], resolve) },
      { path: 'reset-passwordEn', name: 'reset-passwordEn', component: (resolve) => require(['@views/pages/audienceEn/login/components/reset-password'], resolve) },
      { path: 'reset-passwordEn2', name: 'reset-passwordEn2', component: (resolve) => require(['@views/pages/audienceEn/login/components/reset-password2'], resolve) },
      { path: 'succeedEn', name: 'succeedEn', component: (resolve) => require(['@views/pages/audienceEn/login/components/succeed'], resolve) },
      { path: 'succeedEn2', name: 'succeedEn2', component: (resolve) => require(['@views/pages/audienceEn/login/components/succeed2'], resolve) },
    ]
  },
  { // 邀请函 
    path: '/inviteEn',
    name: '/inviteEn',
    component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/inviteEn'], resolve)
  },
  // 参展申请 - 登录 
  { 
    path: '/join-loginEn',
    name: '/join-loginEn',
    component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/login'], resolve)
  },
  {
    path: '/', name: 'AudienceHome1', component: AudienceHome1,
    children: [{ // 首页
      path: 'home',
      name: 'home',
      component: Home
    },
      { // 参展申请
        path: 'join',
        name: 'join',
        component: (resolve) => require(['@views/pages/audienceEn/joinExEn/index'], resolve),
        redirect: "/join/basicEn",
        children: [
          { // 基本信息
            path: 'basicEn',
            name: 'basicEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/basic'], resolve)
          },
          { // 选择入口
            path: 'entranceEn',
            name: 'entranceEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/entrance'], resolve)
          },
          { // 选择订单
            path: 'orderEn',
            name: 'orderEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/order'], resolve)
          },
          { // 会刊信息
            path: 'catalogueEn',
            name: 'catalogueEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/catalogue'], resolve)
          },
          { // 报名表
            path: 'applicationEn',
            name: 'applicationEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/application'], resolve)
          },
          { // 完成
            path: 'finishEn',
            name: 'finishEn',
            component: (resolve) => require(['@views/pages/audienceEn/joinExEn/subpages/finish'], resolve)
          },
        ]
      },
      { // 展团参展申请
        path: 'join/pavilion',
        name: 'join/pavilion',
        component: (resolve) => require(['@views/pages/audienceEn/Pavilion/index'], resolve),
        redirect: "/join/pavilion/basic",
        children: [
          { // 基本信息
            path: 'basicEn',
            name: 'basicEn',
            component: (resolve) => require(['@views/pages/audienceEn/Pavilion/subpages/basic'], resolve)
          },
          // { // 选择入口
          //   path: 'entrance',
          //   name: 'entrance',
          //   component: (resolve) => require(['@views/pages/audience/joinEx/subpages/entrance'], resolve)
          // },
          { // 选择订单
            path: 'orderEn',
            name: 'orderEn',
            component: (resolve) => require(['@views/pages/audienceEn/Pavilion/subpages/order'], resolve)
          },
          { // 会刊信息
            path: 'catalogueEn',
            name: 'catalogueEn',
            component: (resolve) => require(['@views/pages/audienceEn/Pavilion/subpages/catalogue'], resolve)
          },
          { // 报名表
            path: 'applicationEn',
            name: 'applicationEn',
            component: (resolve) => require(['@views/pages/audienceEn/Pavilion/subpages/application'], resolve)
          },
          { // 完成
            path: 'finishEn',
            name: 'finishEn',
            component: (resolve) => require(['@views/pages/audienceEn/Pavilion/subpages/finish'], resolve)
          },
        ]
      },
    ]
  }
]


export {
  AudienceEnRouter,
}; 
